// @flow
import type { Dispatch, GetState } from 'statsradio/types/Store';
import { pushNotification, readNotification } from 'common/modules/ui/actions/uiActions';
import { getUser } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import { EstimationProgress } from '../domain/estimationProgress';
import { getStationProgress } from '../selectors/salesSelectors';
import SalesEstimationNotification from '../../notifications/domain/SalesEstimationNotification';

export const ESTIMATE_SALES_PROGRESS = 'sales/ESTIMATE_SALES_PROGRESS';

export function updateProgress(progress: EstimationProgress) {
  return async (dispatch: Dispatch, getState: GetState) => {
    const user = getUser(getState());
    if (!user) {
      return;
    }

    const radio = user.radios.find(r => r.callSign === progress.callSign);
    if (!radio) {
      return;
    }

    dispatch({ type: ESTIMATE_SALES_PROGRESS, progress });

    const toNotify =
      getStationProgress(getState(), progress.callSign)
        .find(p => p.progress.reference === progress.reference);

    if (!toNotify) {
      return;
    }

    const notification = new SalesEstimationNotification({
      title: 'notifications:estimationSuccess',
      message: 'notifications:estimationClickHere',
      url: `/estimations/${progress.reference}`,
      radio: radio,
      reference: progress.reference,
      toast: progress.is('SUCCESS') || progress.is('ERROR'),
      estimationReference: progress.reference,
      estimationProgress: toNotify,
    });

    dispatch(pushNotification(notification));
  };
}

export function markSalesNotificationAsRead(estimationReference: string) {
  return readNotification(estimationReference);
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/actions/salesNotificationsActions.js